
import React from 'react';
import { CoreFormItem } from 'components/core/library/form';

import './formItem.scss';

export default function FormItem(props) {
	return (
		<CoreFormItem {...props} />
	);
}
